import {
    EmployeeAvatarRenderer,
    RemoveEmployeeRenderer,
    RemoveLoganUserRenderer,
    LoganUserRenderer,
    LoganUserRolesRenderer,
    DateRenderer,
} from "./CellRenderers";

export const DEFAULT_COLUMN_DEF = {
    sortable: true,
    floatingFilter: true,
    filter: "agTextColumnFilter",
};

export const STATUS_BAR = {
    statusPanels: [
        { statusPanel: "agTotalAndFilteredRowCountComponent", align: "left" },
        { statusPanel: "agTotalRowCountComponent", align: "center" },
        { statusPanel: "agFilteredRowCountComponent" },
        { statusPanel: "agSelectedRowCountComponent" },
        { statusPanel: "agAggregationComponent" },
    ],
};

export const GRID_OPTIONS = {
    suppressScrollOnNewData: true,
};

const REMOVE_COLUMN_CONFIG = {
    field: "remove",
    headerName: "Remove",
    filter: false,
    sortable: false,
    suppressMenu: true,
    floatingFilter: false,
    suppressMovable: true,
    checkboxSelection: false,
    lockPosition: true,
    width: 100,
};

export const SUPER_USERS_COLUMNS = [
    {
        field: "name",
        headerName: "Name",
        sort: "asc",
        cellRenderer: EmployeeAvatarRenderer,
    },
    {
        headerName: "Email",
        field: "email",
    },
    {
        headerName: "Company",
        field: "company",
    },
    {
        headerName: "Created At",
        field: "createdAt",
        filter: "agDateColumnFilter",
    },
    {
        headerName: "Last Seen",
        field: "lastSeen",
        filter: "agDateColumnFilter",
    },
    {
        ...REMOVE_COLUMN_CONFIG,
        cellRenderer: RemoveEmployeeRenderer,
    },
];

export const LOGAN_USERS_COLUMNS = [
    {
        field: "displayName",
        headerName: "Name",
        cellRenderer: LoganUserRenderer,
        comparator: (valueA, valueB) => {
            const a = (valueA || "").toLowerCase();
            const b = (valueB || "").toLowerCase();
            return a.localeCompare(b);
        },
    },
    {
        headerName: "Email",
        field: "email",
    },
    {
        headerName: "Account Type",
        field: "accountType",
    },
    {
        headerName: "Roles",
        field: "roles",
        cellRenderer: LoganUserRolesRenderer,
    },
    {
        headerName: "Created At",
        field: "createdAt",
        filter: "agDateColumnFilter",
        sort: "desc",
        cellRenderer: DateRenderer,
    },
    {
        ...REMOVE_COLUMN_CONFIG,
        cellRenderer: RemoveLoganUserRenderer,
    },
];